import { getEmailRecipient } from "../../../../../actions/Utilities/EmailRecipient";
import { useQuery } from "react-query";

export default function useEmailRecipient() {
  const { data, isFetching } = useQuery("GetEmailRecipient", getEmailRecipient, {
    refetchOnWindowFocus: false,
  });
  return {data, isFetching};
}
